<context-menu #taskActionMenu class="container">
    <ng-template contextMenuItem (execute)="addNode('input')">
        <div class="task-type-item">
            <span>{{'workflow.input_task' | stringLiterals}}</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem (execute)="addNode('approval')">
        <div class="task-type-item">
            <span>{{'workflow.approval_task' | stringLiterals}}</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem (execute)="addNode('parallel')" [disabled]="isGrandChildOfGatewayNode">
        <div class="task-type-item">
            <span>{{'workflow.parallel_gateways' | stringLiterals}}</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem (execute)="addNode('conditional')" [disabled]="isGrandChildOfGatewayNode">
        <div class="task-type-item">
            <span>{{'workflow.conditional_gateway' | stringLiterals}}</span>
        </div>
    </ng-template>
    <context-menu #automationList>
        <ng-template contextMenuItem *ngFor="let action of automationSubMenuItems" (execute)="addAutomation(action)"
            [disabled]="!isTamaleAutomationEnabled || !action.enable">
            <div class="task-container">
                <span title="{{action.name | stringLiterals}}">{{action.name | stringLiterals}}</span>
            </div>
        </ng-template>
    </context-menu>
    <ng-template contextMenuItem [subMenu]="automationList" [disabled]="!isTamaleAutomationEnabled">
        <div class="task-automation-action">
            <div class="menu-item">
                <span>{{'workflow.tamale_automation' | stringLiterals}}</span>
            </div>
            <smart-icon class="menu-icon" name="angle-right"></smart-icon>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true"></ng-template>
    <context-menu #taskList>
        <ng-template contextMenuItem let-item *ngFor="let task of currentAllTasks" (execute)="moveTask(task)"
            [disabled]="!task.enable">
            <div class="task-container">
                <span [title]="task.name">{{task.name}}</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="allAutomationNodes && allAutomationNodes.length>0">
        </ng-template>
        <ng-template contextMenuItem let-item *ngFor="let automationNode of allAutomationNodes"
            (execute)="moveAutomationNode(automationNode)"
            [disabled]="!isTamaleAutomationEnabled || !automationNode.enable">
            <div class="task-container">
                <span [title]="automationNode.name">{{automationNode.name}}</span>
            </div>
        </ng-template>
    </context-menu>
    <ng-template contextMenuItem let-item [subMenu]="isMoveItemEnabled && taskList" [disabled]="!isMoveItemEnabled">
        <div class="move-task-action">
            <div class="menu-item">
                <span>{{'workflow.move' | stringLiterals}}</span>
            </div>
            <smart-icon class="menu-icon" name="angle-right"></smart-icon>
        </div>
    </ng-template>
</context-menu>